<template>
    <CookieIcon v-if="optIn && !showCookieBanner" @clicked="onCookieIconClicked" />
    <div v-else class="cookie-banner">
        <p class="h2">
            <MySvg :icon="'cookie'" />Cookies
        </p>
        <div class="flex-col justify-space-between">

            <ul class="list-blank cookies">
                <li class="mb-8" v-for="item in cookies" v-if="item.services.length > 0">
                    <Cookie :id=item.id :title=item.title :desc=item.desc :essential=item.essential
                            :services=item.services />
                </li>
            </ul>

            <div class="d-flex justify-space-between buttons">
                <button class="btn btn-primary no-border" type="button" @click="onAcceptAll"
                        :title="LANG.cookieBanner.buttons.acceptAll">
                    {{ LANG.cookieBanner.buttons.acceptAll }}
                </button>
                <button class="btn btn-sec" type="button" @click="onSavePreferences"
                        :title="LANG.cookieBanner.buttons.savePrefs">
                    {{ LANG.cookieBanner.buttons.savePrefs }}
                </button>
                <button class="btn btn-secondary" type="button" @click="onDecline"
                        :title="LANG.cookieBanner.buttons.decline">
                    {{ LANG.cookieBanner.buttons.decline }}
                </button>
            </div>
        </div>
    </div>
</template>


<script>

import LANG from "../../i18n/loader"
import Cookies from "../../helper/cookies"
import MySvg from "../Svg.vue"
import Cookie from "./Cookie.vue"
import CookieIcon from "./CookieIcon.vue"

export default {
    data: () => {
        return {
            LANG,
            optIn: false,
            showCookieBanner: false,
            cookieOptions: [],
            scripts: [],
            cookieConsent: {},
            cookies: {
                essentials: {
                    id: "essentials",
                    title: LANG.cookieBanner.essentials.title,
                    desc: LANG.cookieBanner.essentials.desc,
                    essential: true,
                    services: ["Session Cookie"],
                },
                functionality: {
                    id: "functionality",
                    title: LANG.cookieBanner.functionality.title,
                    desc: LANG.cookieBanner.functionality.desc,
                    services: [],
                },
                analytics: {
                    id: "analytics",
                    title: LANG.cookieBanner.analytics.title,
                    desc: LANG.cookieBanner.analytics.desc,
                    services: ["Google Tag Manager"],
                },
            },
        }
    },
    components: {
        MySvg,
        Cookie,
        CookieIcon,
    },
    methods: {
        onAcceptAll() {
            this.cookieOptions.forEach(co => {
                this.cookieConsent[co.id] = true
            })

            this.saveCookies()
        },
        onSavePreferences() {
            this.cookieOptions.forEach(co => {
                this.cookieConsent[co.id] = (this.cookies[co.id].essential || co.checked)
            })

            this.saveCookies()
        },
        onDecline() {
            this.cookieOptions.forEach(co => {
                if (this.cookies[co.id].essential) {
                    this.cookieConsent[co.id] = true
                    return
                }

                this.cookieConsent[co.id] = false
            })

            this.saveCookies()
        },
        saveCookies() {
            this.handleScripts()

            Cookies.set('cookie_consent', JSON.stringify(this.cookieConsent))

            this.optIn = true
            this.showCookieBanner = false
        },
        onCookieIconClicked() {
            this.showCookieBanner = true

            this.$nextTick(() => {
                this.cookieOptions = document.querySelectorAll('.cookie-banner .cookies input[type="checkbox"]')
                this.recheckCheckboxes()
            })
        },
        handleScripts() {
            for (const key in this.cookieConsent) {
                if (this.cookieConsent[key]) {
                    this.scripts.forEach(script => {
                        if (script.dataset.cookieType == key) {
                            script.setAttribute("type", script.dataset.type)
                            script.setAttribute("src", script.dataset.src)
                        }
                    })
                }
                else {
                    //disable scripts
                }
            }
        },
        recheckCheckboxes() {
            this.cookieOptions.forEach(co => {
                if (this.cookies[co.id].essential) {
                    co.checked = true
                    return
                }

                co.checked = this.cookieConsent[co.id]
            })
        },
    },
    created() {
        const cookieContent = Cookies.get('cookie_consent')
        if (cookieContent !== null) {
            this.cookieConsent = JSON.parse(cookieContent)
            this.optIn = true
        }

        this.scripts = document.querySelectorAll('head script[type="text/plain"]')
    },
    mounted() {
        this.cookieOptions = document.querySelectorAll('.cookie-banner .cookies input[type="checkbox"]')

        if (Cookies.get('cookie_consent') === null)
            return

        this.handleScripts()
    }
}
</script>